module.exports = __webpack_public_path__ + "static/media/open.f611b98a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/open.svg
// module id = 289
// module chunks = 0